import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Flex, SxProps, Text } from '@modusign/design-system';

interface NotAnOriginalDocumentInlineAlertProps extends SxProps {}

export default function NotAnOriginalDocumentInlineAlert({
  sx,
}: NotAnOriginalDocumentInlineAlertProps) {
  return (
    <Flex
      bg="notificationBackgroundPrimaryBase"
      border="1px solid"
      borderColor="notificationBorderPrimaryBase"
      borderRadius="3px"
      px={6}
      py={5}
      sx={sx}
    >
      <Box
        as={FontAwesomeIcon}
        color="iconPrimaryDark"
        fontSize="14px"
        icon={faExclamationCircle}
        mr={3}
        mt={1}
      />
      <div>
        <Text as="div" fontWeight="medium">
          가지고 계신 계약서와 첨부파일 원본은 계속 보관해 주세요.
        </Text>
        <Text as="div" mt="2px">
          외부문서에 등록한 파일은 관리를 위한 사본입니다.
        </Text>
      </div>
    </Flex>
  );
}
